import moment from 'moment-timezone';
import { EChartOption } from 'echarts/lib/echarts';
import {
  convertStateDataToChart,
  convertEventDataToChart,
  renderStateItem,
  renderEventItem,
} from '../../utils/converDataToChart';
import generateGraphic from '../../utils/generateGraphic';
import getGranularity from '../../utils/getGranularity';

export default ({
  range,
  stateData,
  eventData,
  dateRange,
  chartWidth,
}): EChartOption => {
  // rangeOverlay indicates how much time for current granularity one icon has
  const stateChartData = convertStateDataToChart(stateData);
  const eventChartData = convertEventDataToChart(eventData, range, dateRange);
  const startLimit = dateRange[0];
  const endLimit = dateRange[dateRange.length - 1];
  const g = getGranularity(startLimit, endLimit);
  const diff = moment(endLimit).diff(startLimit, g);
  const timeFormat = g === 'm' ? 'HH:mm' : 'HH:mm:ss';

  const option = {
    tooltip: { show: false },
    grid: {
      show: false,
      left: 100,
      height: 30,
      right: 100,
      top: 68,
    },
    graphic: generateGraphic({ width: chartWidth + 40, x: 100 }),
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: (value, index) => {
            // Show more date detail on first and last moment
            if (index === 0 || value === dateRange[dateRange.length - 1]) {
              return `${moment(value).format(timeFormat)}\n ${moment(value).format(
                'MMM DD,YYYY',
              )}`;
            }

            return moment(value).format(timeFormat);
          },
        },
        min: startLimit,
        max: endLimit,
        data: dateRange,
        splitLine: {
          show: false,
        },
        splitNumber: Math.min(14, diff),
      },
      {
        show: false,
        type: 'time',
        min: startLimit,
        max: endLimit,
        data: dateRange,
      },
    ],
    dataZoom: {
      show: true,
      showDataShadow: false,
      xAxisIndex: 1,
      type: 'slider',
      bottom: 100,
      top: 68,
      // handleIcon: `image://${zoomHandler}`,
      handleSize: '30',
      handleStyle: {
        color: '#0046ff',
      },
      filterMode: 'none',
      backgroundColor: 'transparent',
      fillerColor: 'rgba(0, 70, 255, 0.2)',
      textStyle: {
        color: '#000',
        lineHeight: 17,
        fontWeight: 'bold',
        textBorderWidth: 2,
        padding: 0,
      },
      minSpan: 1,
      labelFormatter: value => moment(value).format('MMM DD HH:mm'),
    },
    yAxis: {
      show: false,
    },
    series: [
      {
        type: 'custom',
        renderItem: (p, a) => renderEventItem(p, a, startLimit, endLimit),
        data: eventChartData,
        encode: {
          x: 0,
          y: 0,
        },
      },
      {
        type: 'custom',
        renderItem: renderStateItem,
        clip: true, // clip the redundant chart.
        encode: {
          x: [1, 2],
          y: 0,
        },
        data: stateChartData,
      },
    ],
  };

  return option;
};
